class BaseRequestBuilder {
  isFilterContainInvalidValue({ invalid }) {
    return invalid;
  }
  mapToFilterObject(filter) {
    const result = {};
    const searchParams = new URLSearchParams(filter);
    searchParams.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  }
  toMultiselectFilter(filter, filterName, isArrayInString) {
    if (!(filterName in filter)) return void 0;
    const raw = filter[filterName];
    if (isArrayInString && typeof raw === "string") {
      return raw.split(/[\s,]+/).filter(Boolean);
    }
    return this.getMultiselectFilterList(raw) ?? raw;
  }
  toStringFilter(filter, filterName) {
    return this.parseJSONFilter(filter, filterName)?.toString();
  }
  toObjectFilter(filter, filterName) {
    const value = this.parseJSONFilter(filter, filterName);
    return typeof value === "object" ? value : void 0;
  }
  toBooleanFilter(filter, filterName) {
    return !!this.parseJSONFilter(filter, filterName);
  }
  toGQLBooleanSelectFilter(filter, filterName) {
    return filterName in filter ? filter[filterName] === "true" : void 0;
  }
  toNumberFilter(filter, filterName) {
    const value = Number(this.parseJSONFilter(filter, filterName));
    return isNaN(value) || value === null || value === void 0 ? void 0 : value;
  }
  buildPaging(filter) {
    const defaultPaging = { end: 10, start: 0 };
    return filter.page && filter.size ? {
      start: (filter.page - 1) * filter.size,
      end: filter.page * filter.size
    } : defaultPaging;
  }
  getMultiselectFilterList(serializedFilter) {
    try {
      const value = JSON.parse(serializedFilter);
      return Array.isArray(value) ? value?.flatMap((v) => v) : null;
    } catch {
      return null;
    }
  }
  parseJSONFilter(filter, filterName) {
    let result;
    if (filterName in filter) {
      try {
        result = JSON.parse(filter[filterName]);
      } catch {
        result = filter[filterName];
      }
    } else {
      return void 0;
    }
    return result;
  }
}
export {
  BaseRequestBuilder
};
//# sourceMappingURL=BaseRequestBuilder.js.map
